<template>
  <header class="home-header">
    <section class="home-header__top">
      <div class="home-header__logo">
        <h1>Ophelia Fournier-Laflamme — Designer who codes</h1>
      </div>

     <div class="home-header__socials">
        <a href="https://www.linkedin.com/in/ophelia-fournier-laflamme-4555b511b/" target="_blank" rel="noopener" class="home-header__icon -smaller">
          <svg-icon id="social-linkedin" />
        </a>

        <a href="https://codepen.io/opheliafl" target="_blank" rel="noopener" class="home-header__icon">
          <svg-icon id="social-codepen" />
        </a>

        <a href="https://dribbble.com/ophelia-fl" target="_blank" rel="noopener" class="home-header__icon">
          <svg-icon id="social-dribbble" />
        </a>

        <a href="https://www.behance.net/ophelia-fl" target="_blank" rel="noopener" class="home-header__icon">
          <svg-icon id="social-behance" />
        </a>

        <a href="mailto:info@ofl.design" class="home-header__icon -active">
          <svg-icon id="social-mail-2" />
        </a>
      </div>
    </section>

    <h3 class="home-header__banner">Passionate about interface design and specialized in advanced css, I thrive to push the limits of my talents to captivate my audience through <span>interfaces that are as intuitive as they are beautiful</span>.</h3>
  </header>
</template>

<script>
/* import HomeAbout from './HomeAbout.vue' */

export default {
  name: 'HomeHeader'
  /* components: { HomeAbout } */
}
</script>
